import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { AdminAccessRequestDetail } from 'src/app/O3AdministrationComponents/admin-access-requests/models/detail';
import { AdminAccessReceivedRow, AdminAccessSentRow, ApproveRejectRequest } from 'src/app/O3AdministrationComponents/admin-access-requests/models/grid';
import { SwitchClickRequest, SwitchClickResponse, SwitchIconStatus, SwitchIconStatusQuery } from 'src/app/user-management/user-management-setup/models/switch-account';

import { BaseApi } from 'src/backend/api/base-api';

@Injectable({ providedIn: 'root' })
export class AdminAccessApprovalService {
  constructor(private baseApi: BaseApi, private http: HttpClient) { }

  switchClick(body: SwitchClickRequest): Observable<SwitchClickResponse> {
    return this.http.post<SwitchClickResponse>(
      this.baseApi.encodeURL(Constants.API_ADMIN_ACCESS_SWITCH_CLICK),
      body
    );
  }

  approve(id: number, body: ApproveRejectRequest = {}): Observable<any> {
    return this.http.put<any>(
      this.baseApi.encodeURL(`${Constants.API_ADMIN_ACCESS_APPROVE}/${id}`),
      body
    );
  }

  reject(id: number, body: ApproveRejectRequest = {}): Observable<any> {
    return this.http.put<any>(
      this.baseApi.encodeURL(`${Constants.API_ADMIN_ACCESS_REJECT}/${id}`),
      body
    );
  }

  getSent(filter: any): Observable<{ data: AdminAccessSentRow[]; totalCount: number }> {
    return this.http.post<{ data: AdminAccessSentRow[]; totalCount: number }>(
      this.baseApi.encodeURL(Constants.API_ADMIN_ACCESS_SENT),
      filter ?? {}
    );
  }

  getReceived(filter: any): Observable<{ data: AdminAccessReceivedRow[]; totalCount: number }> {
    return this.http.post<{ data: AdminAccessReceivedRow[]; totalCount: number }>(
      this.baseApi.encodeURL(Constants.API_ADMIN_ACCESS_RECEIVED),
      filter ?? {}
    );
  }

  getById(id: number): Observable<AdminAccessRequestDetail> {
    return this.http.get<AdminAccessRequestDetail>(
      this.baseApi.encodeURL(`${Constants.API_ADMIN_ACCESS_GET_BY_ID}/${id}`)
    );
  }

  // Bulk badge lookup for User Management. Missing targets get no badge on the client.
  getStatus(targetUserIds: string[]): Observable<SwitchIconStatus[]> {
    const body: SwitchIconStatusQuery = { targetUserIds };
    return this.http.post<SwitchIconStatus[]>(
      this.baseApi.encodeURL(Constants.API_ADMIN_ACCESS_STATUS),
      body
    );
  }
}
